import { Point } from '../../utils/Point';
import { TweenMax } from 'gsap/TweenMax';
import { canvasView, CanvasView } from './CanvasView';
import { hexToRgb, mod } from '../../utils/MathHelpers';
import { WindowManager } from '../../utils/WindowManager';

export class BackgroundGradient {
	private context: CanvasRenderingContext2D;
	private radius: number = 0;
	private panPosition: Point = { x: 0, y: 0 };
	private easedPanPoint: Point = { x: 0, y: 0 };
	private originPoint: Point = { x: 0, y: 0 };
	private easeAmount = 30;
	private parent: CanvasView;
	private origin: Point;
	private innerColor: string = 'rgba(255,255,255,0)';
	private outerColor: string = 'rgba(255,255,255,0)';

	constructor(context: CanvasRenderingContext2D, parent: CanvasView, radius: number, origin: Point) {
		this.context = context;
		this.parent = parent;
		this.radius = radius;
		this.origin = origin;
	}

	public setPanPosition(position: Point) {
		this.panPosition = position;
	}

	public setColor(innerColor: string, outerColor: string, speed) {
		const rgbaInner = hexToRgb(innerColor);
		const rgbaOuter = hexToRgb(outerColor);
		const rgbaInnerString = 'rgba(' + rgbaInner.r + ', ' + rgbaInner.g + ', ' + rgbaInner.b + ', .7)';
		const rgbaOuterString = 'rgba(' + rgbaOuter.r + ', ' + rgbaOuter.g + ', ' + rgbaOuter.b + ', 0)';
		TweenMax.to(this, speed, { innerColor: rgbaInnerString, outerColor: rgbaOuterString });
	}

	public resize() {
		this.originPoint = {
			x: this.origin.x * canvasView.entireCanvasSize.width,
			y: this.origin.y * canvasView.entireCanvasSize.height
		};
	}

	public render() {
		this.easedPanPoint.x += (this.panPosition.x - this.easedPanPoint.x) / (this.easeAmount * this.parent.easeModifier);
		this.easedPanPoint.y += (this.panPosition.y - this.easedPanPoint.y) / (this.easeAmount * this.parent.easeModifier);
		const x = mod(this.originPoint.x + this.easedPanPoint.x, canvasView.entireCanvasSize.width) - (canvasView.entireCanvasSize.width - WindowManager.landingWidth) / 2;
		const y = mod(this.originPoint.y + this.easedPanPoint.y, canvasView.entireCanvasSize.height) - (canvasView.entireCanvasSize.height - WindowManager.landingHeight) / 2;
		const gradient = this.context.createRadialGradient(x, y, 0, x, y, this.radius);
		gradient.addColorStop(0, this.innerColor);
		gradient.addColorStop(1, this.outerColor);
		this.context.arc(x, y, this.radius, 0, 2 * Math.PI);
		this.context.closePath();
		this.context.fillStyle = gradient;
		this.context.fill();
	}
}
